var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slice',{staticClass:"block--line-of-blocks",style:({
    '--number-of-blocks': _vm.block.blocks.length,
  }),attrs:{"id":_vm.block._key},on:{"in":function($event){return _vm.$emit('in')},"out":function($event){return _vm.$emit('out')}}},[(_vm.block.blocks && _vm.block.blocks.length > 0)?_c('blocks',{attrs:{"blocks":_vm.block.blocks,"entities":_vm.entities,"is-home":_vm.isHome,"is-on-top-of-page":_vm.isOnTopOfPage,"origin":_vm.origin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }